import { useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useSelector } from 'react-redux';
import { selectMCBySwitch } from 'shared/slice/masterControlBySwitchSelectSlice';
import { selectMCByLocation } from 'shared/slice/masterControlSelectByLocationSlice';
import { selectUnits } from 'shared/slice/unitsSlice';


import SelectLocations from './SelectLocations';
import InputTempMessage from 'shared/components/userMessages/inputTempMessage';
import MobileControlLayout from 'features/masterControl/components/shared/MobileControlLayout';
import { validateTemp, TEMP_ERROR_MESSAGES } from 'features/masterControl/components/shared/tempValidation';

import {
  SwitchCardWrapper,
  SwitchCardTitle,
  SwitchSectionTop,
  SwitchFormController,
  SwitchInputSection,
  SwitchInputTemp,
  SwitchButtonSection,
} from 'features/masterControl/components/shared/styles/switchCardStyles';

import {
  SwitchButtonWrapper,
  SwitchButtonHole,
  SwitchButtonTop,
  MessageBoxWrapper,
} from 'features/masterControl/components/shared/styles/controlButtons';

const OptionalConstant = ({
  scope,
  swtName,
  handleOnClick,
  disabled,
  handleClose,
  specificLocation,
}) => {
  const isMobile = useMediaQuery({ query: '(max-width:600px)' });
  const type = scope === 'switch' ? 'locations' : 'switches';

  const switchStatus = useSelector(
    scope === 'switch' ? selectMCBySwitch : selectMCByLocation
  );
  const { selectedOne } = switchStatus.optionalConstant;

  const unitsStatus = useSelector(selectUnits);
  const { isF } = unitsStatus;

  const [tempInput, setTempInput] = useState('');
  const [openMessageBox, setOpenMessageBox] = useState(false);
  const [messages, setMessages] = useState([]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (disabled) {
      return;
    }

    if (!selectedOne) {
      handleOnClick('constantTemp', 'selectA', scope, '_', '_', type);
      setOpenMessageBox(true);
      setMessages(TEMP_ERROR_MESSAGES.selectLocation);
    } else {
      const temp = Number(tempInput);
      if (validateTemp(temp, 'constantTemp', isF)) {
        handleOnClick('constantTemp', 'on', scope, temp);
        setTempInput('');
        if (isMobile && scope !== 'switch') {
          handleClose();
        }
      } else {
        setOpenMessageBox(true);
        setMessages(TEMP_ERROR_MESSAGES.constantTemp);
      }
    }
  };

  const logoSrc = disabled
    ? 'images/logo-constantTemp-disabled.svg'
    : 'images/logo-constantTemp.svg';

  if (isMobile) {
    return (
      <MobileControlLayout
        scope={scope}
        swtName={swtName}
        specificLocation={specificLocation}
        controlName='optionalConstant'
        logoSrc={logoSrc}
        label={
          <>
            opt. const.<br />temperature<br />program
          </>
        }
        labelSmall={
          <>
            opt. const.<br />temperature
          </>
        }
        disabled={disabled}
        hasInput
        tempInput={tempInput}
        onTempChange={(e) => setTempInput(e.target.value)}
        placeholder={isF ? '0\u00B0F' : '0 \u00B0C'}
        onApply={handleSubmit}
        onSubmit={handleSubmit}
        subtitle='optional constant program'
        messages={messages}
        openMessageBox={openMessageBox}
        onCloseMessageBox={() => setOpenMessageBox(false)}
      />
    );
  }

  return (
    <SwitchCardWrapper disabled={disabled} $watermark='images/logo-constantTemp.svg'>
      <SwitchSectionTop disabled={disabled}>
        <SwitchCardTitle disabled={disabled}>opt.const.temp.program</SwitchCardTitle>

        <SelectLocations
          size={1}
          name='optionalConstant'
          scope={scope}
          swtName={swtName}
          disabled={disabled}
          specificLocation={specificLocation}
        />
      </SwitchSectionTop>

      <SwitchFormController onSubmit={handleSubmit} disabled={disabled}>
        <SwitchInputSection disabled={disabled}>
          <SwitchInputTemp
            type='text'
            onChange={(e) => setTempInput(e.target.value)}
            value={tempInput}
            placeholder='input temperature'
            disabled={disabled}
          />
        </SwitchInputSection>

        <SwitchButtonSection>
          <SwitchButtonWrapper onClick={handleSubmit} disabled={disabled}>
            <SwitchButtonHole disabled={disabled}>
              <SwitchButtonTop disabled={disabled}>apply</SwitchButtonTop>
            </SwitchButtonHole>
          </SwitchButtonWrapper>
        </SwitchButtonSection>

        {openMessageBox && (
          <MessageBoxWrapper>
            <InputTempMessage
              onClose={() => setOpenMessageBox(false)}
              title='master control'
              messages={messages}
            />
          </MessageBoxWrapper>
        )}
      </SwitchFormController>
    </SwitchCardWrapper>
  );
};

export default OptionalConstant;
